module.exports = __webpack_public_path__ + "static/media/adminlogo.3413c41f.png";